<app-modal
  title="Edit Category"
  subtitle="Update the name of this category."
  (closed)="closed.emit()"
>
  <div class="flex flex-col gap-1.5 mb-2">
    <label class="text-xs font-semibold text-navy-600 tracking-wider">Category Name</label>
    <input
      type="text"
      placeholder="Type name..."
      [value]="categoryName()"
      (input)="categoryName.set($any($event.target).value)"
      [class.border-red-400]="showErrors() && !categoryName().trim()"
      [class.ring-2]="showErrors() && !categoryName().trim()"
      [class.ring-red-100]="showErrors() && !categoryName().trim()"
      class="w-full"
    />
    @if (showErrors() && !categoryName().trim()) {
      <span class="text-2xs text-red-500">Required</span>
    }
  </div>

  <div modal-footer class="flex items-center justify-between gap-3">
    @if (confirmRemove()) {
      <div class="flex items-center gap-2">
        <span class="text-xs text-slate-500">Delete this category?</span>
        <button
          type="button"
          (click)="onRemove()"
          [disabled]="removing()"
          class="px-3 py-1.5 text-xs font-semibold text-white bg-red-500 hover:bg-red-600 rounded-lg transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {{ removing() ? 'Deleting...' : 'Confirm' }}
        </button>
        <button
          type="button"
          (click)="confirmRemove.set(false)"
          [disabled]="removing()"
          class="px-3 py-1.5 text-xs font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
        >
          Cancel
        </button>
      </div>
    } @else {
      <button
        type="button"
        (click)="onRemove()"
        class="flex items-center gap-1.5 text-xs font-semibold text-red-500 hover:text-red-600 transition-colors cursor-pointer"
      >
        <img src="/icons/trash-icon.svg" class="w-4 h-4" alt="" />
        Delete category
      </button>
    }

    <div class="flex items-center gap-3">
      <button
        type="button"
        (click)="closed.emit()"
        class="px-6 py-2.5 text-sm font-semibold text-slate-500 hover:text-navy-900 transition-colors cursor-pointer"
      >
        Cancel
      </button>
      <button
        type="button"
        (click)="onSubmit()"
        [disabled]="submitting() || !hasChanges()"
        class="px-6 py-2.5 text-sm font-semibold text-white bg-accent-500 hover:opacity-90 rounded-xl transition-opacity cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {{ submitting() ? 'Saving...' : 'Save Changes' }}
      </button>
    </div>
  </div>
</app-modal>
